import script from "./object_header_image.vue?vue&type=script&setup=true&lang=js"
export * from "./object_header_image.vue?vue&type=script&setup=true&lang=js"

import "./object_header_image.vue?vue&type=style&index=0&id=5f9d95a9&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9d95a9"]])

export default __exports__